export enum ReferralEntityType {    
    ClinicContact = 1,
    GaretsBook = 2
}